<template>
  <div class="silly-api-keys-container">
    <!-- Search and Action Section -->
    <div style="display: flex">
      <div>
        <el-input
            v-model="searchForm.keyApi"
            placeholder="搜索API Key"
            clearable
            size="small"
            @clear="handleClear('keyApi')"
            @input="handleSearch">
        </el-input>
      </div>
      <div style="padding-left: 10px;padding-right: 10px">
        <el-button type="primary" size="small" @click="fetchApiKeys">查询</el-button>
      </div>
      <div>
        <el-button type="success" size="small" @click="dialogVisible = true">新增API Key</el-button>
        <el-dialog title="新增API Key" :visible.sync="dialogVisible" width="30%" @close="resetForm">
          <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="API Key" :rules="{ required: true, message: 'API Key不能为空', trigger: 'blur' }">
              <el-input v-model="form.keyApi"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-select v-model="form.isSurvive" placeholder="请选择状态">
                <el-option label="启用" value="1"></el-option>
                <el-option label="禁用" value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮箱">
              <el-input v-model="form.email"></el-input>
            </el-form-item>
            <el-form-item label="过期时间">
              <el-date-picker
                  v-model="form.expireTime"
                  type="datetime"
                  placeholder="选择过期时间">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">确定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>

    <!-- Table Section -->
    <el-table
        :data="apiKeys"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange">
      <el-table-column
          type="selection"
          width="55">
      </el-table-column>
      <el-table-column
          type="index"
          label="序号"
          width="60">
      </el-table-column>
      <el-table-column
          prop="keyApi"
          label="API Key"
          width="300">
      </el-table-column>
      <el-table-column
          prop="isSurvive"
          label="状态"
          width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.isSurvive === '1' ? 'success' : 'danger'">
            {{ scope.row.isSurvive === '1' ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="email"
          label="邮箱">
      </el-table-column>
      <el-table-column
          prop="expirationTime"
          label="过期时间"
          width="180">
        <template slot-scope="scope">
          {{ formatDate(scope.row.expirationTime) }}
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          width="150">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="primary"
              @click="handleEdit(scope.row)">编辑</el-button>
          <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- Edit Dialog -->
    <el-dialog title="编辑API Key" :visible.sync="editDialogVisible" width="30%" @close="resetEditForm">
      <el-form ref="editForm" :model="editForm" label-width="120px">
        <el-form-item label="API Key" :rules="{ required: true, message: 'API Key不能为空', trigger: 'blur' }">
          <el-input v-model="editForm.keyApi"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="editForm.isSurvive" placeholder="请选择状态">
            <el-option label="启用" value="1"></el-option>
            <el-option label="禁用" value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="editForm.email"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker
              v-model="editForm.expireTime"
              type="datetime"
              placeholder="选择过期时间">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitEditForm('editForm')">确定</el-button>
      </span>
    </el-dialog>

    <!-- Pagination Section -->
    <el-pagination
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalApiKeys">
    </el-pagination>
  </div>
</template>

<script>
import axios from 'axios';
import { Message } from 'element-ui';

export default {
  data() {
    return {
      dialogVisible: false,
      editDialogVisible: false,
      form: {
        keyApi: '',
        isSurvive: '1',
        email: '',
        expireTime: null
      },
      editForm: {
        id: null,
        keyApi: '',
        isSurvive: '1',
        email: '',
        expireTime: null
      },
      searchForm: {
        keyApi: ''
      },
      apiKeys: [],
      totalApiKeys: 0,
      currentPage: 1,
      pageSize: 10,
      multipleSelection: []
    };
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async fetchApiKeys() {
      try {
        const response = await axios.post(`/api/admin/silly/apiKeys/page`, {
          current: this.currentPage,
          size: this.pageSize,
          keyApi: this.searchForm.keyApi
        }, {
          headers: {
            'token': this.$cookies.get('token')
          }
        });

        if (response.data.code === 200 && response.data.data) {
          this.apiKeys = response.data.data.records || [];
          this.totalApiKeys = response.data.data.total || 0;
        } else {
          this.apiKeys = [];
          this.totalApiKeys = 0;
          Message.error(response.data.msg || '获取数据失败');
        }
      } catch (error) {
        Message.error('获取API Keys失败: ' + error.message);
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchApiKeys();
    },
    handleClear(attribute) {
      this.searchForm[attribute] = '';
      this.handleSearch();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchApiKeys();
    },
    formatDate(dateArray) {
      if (!dateArray || !Array.isArray(dateArray) || dateArray.length < 6) {
        return '无限期';
      }

      try {
        // 从数组构建日期对象 [year, month, day, hour, minute, second]
        const date = new Date(
            dateArray[0],     // 年
            dateArray[1] - 1, // 月 (减 1 因为 JS 月份从 0 开始)
            dateArray[2],     // 日
            dateArray[3],     // 时
            dateArray[4],     // 分
            dateArray[5]      // 秒
        );

        // 检查日期是否有效
        if (isNaN(date.getTime())) {
          return '无效日期';
        }

        return date.toLocaleString();
      } catch (error) {
        console.error('Date formatting error:', error);
        return '无效日期';
      }
    },
    resetForm() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.form = {
        keyApi: '',
        isSurvive: '1',
        email: '',
        expireTime: null
      };
    },
    resetEditForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
    },
    async submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const formData = { ...this.form };

            // 将日期对象转换为后端期望的格式
            if (formData.expireTime && formData.expireTime instanceof Date) {
              // 创建年月日时分秒的数组
              formData.expireTime = [
                formData.expireTime.getFullYear(),
                formData.expireTime.getMonth() + 1, // 月份需要加1，因为JS中月份从0开始
                formData.expireTime.getDate(),
                formData.expireTime.getHours(),
                formData.expireTime.getMinutes(),
                formData.expireTime.getSeconds()
              ];
            }

            const response = await axios.post('/api/admin/silly/apiKeys', formData, {
              headers: {
                'token': this.$cookies.get('token'),
                'Content-Type': 'application/json'
              }
            });

            if (response.data.code === 200) {
              this.$message({
                type: 'success',
                message: 'API Key添加成功!'
              });
              this.dialogVisible = false;
              await this.fetchApiKeys();
            } else {
              this.$message.error(response.data.msg || '添加失败');
            }
          } catch (error) {
            this.$message.error('添加API Key时发生错误: ' + error.message);
          }
        } else {
          return false;
        }
      });
    },
    async submitEditForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            const formData = { ...this.editForm };

            // 将日期对象转换为后端期望的格式
            if (formData.expireTime && formData.expireTime instanceof Date) {
              // 创建年月日时分秒的数组
              formData.expireTime = [
                formData.expireTime.getFullYear(),
                formData.expireTime.getMonth() + 1, // 月份需要加1，因为JS中月份从0开始
                formData.expireTime.getDate(),
                formData.expireTime.getHours(),
                formData.expireTime.getMinutes(),
                formData.expireTime.getSeconds()
              ];
            }

            const response = await axios.put('/api/admin/silly/apiKeys', formData, {
              headers: {
                'token': this.$cookies.get('token'),
                'Content-Type': 'application/json'
              }
            });

            if (response.data.code === 200) {
              this.$message({
                type: 'success',
                message: 'API Key更新成功!'
              });
              this.editDialogVisible = false;
              await this.fetchApiKeys();
            } else {
              this.$message.error(response.data.msg || '更新失败');
            }
          } catch (error) {
            this.$message.error('更新API Key时发生错误: ' + error.message);
          }
        } else {
          return false;
        }
      });
    },
    handleEdit(row) {
      // 创建一个基本的editForm对象，不包含日期
      this.editForm = {
        id: row.id,
        keyApi: row.keyApi,
        isSurvive: row.isSurvive,
        email: row.email,
        expireTime: null
      };

      // 如果有过期时间数组，转换为日期对象
      if (row.expirationTime && Array.isArray(row.expirationTime) && row.expirationTime.length >= 6) {
        const [year, month, day, hour, minute, second] = row.expirationTime;
        // 注意：JavaScript Date中月份是从0开始的
        this.editForm.expireTime = new Date(year, month - 1, day, hour, minute, second);
      }

      this.editDialogVisible = true;
    },
    async handleDelete(row) {
      try {
        this.$confirm('确认删除该API Key?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const response = await axios.delete(`/api/admin/silly/apiKeys/${row.id}`, {
            headers: {
              'token': this.$cookies.get('token')
            }
          });

          if (response.data.code === 200) {
            this.$message({
              type: 'success',
              message: 'API Key删除成功!'
            });
            await this.fetchApiKeys();
          } else {
            this.$message.error(response.data.msg || '删除失败');
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$message.error('认证失败，请重新登录');
        } else {
          this.$message.error('删除API Key时发生错误: ' + error.message);
        }
      }
    }
  },
  mounted() {
    this.fetchApiKeys();
  }
}
</script>
